(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protocol-caff"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('exec-protocol');
  if(!root) return;

  var viewport = root.querySelector('.caff-proto-viewport');
  var extract  = viewport.querySelector('.caff-proto-extract');
  var frame    = viewport.querySelector('.caff-proto-frame');
  var items    = [].slice.call(root.querySelectorAll('.caff-proto-data > li'));
  var play     = root.querySelector('[data-protocol-play]');
  var replay   = root.querySelector('[data-protocol-replay]');

  var barA  = extract.querySelector('[data-bar-a] .caff-extract-fill');
  var barB  = extract.querySelector('[data-bar-b] .caff-extract-fill');
  var percA = extract.querySelector('[data-perc-a]');
  var percB = extract.querySelector('[data-perc-b]');

  var title = frame.querySelector('.caff-step-title');
  var body  = frame.querySelector('.caff-step-body');
  var tag   = frame.querySelector('.caff-step-tag');

  var prm   = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var base  = parseInt(root.getAttribute('data-speed') || '26', 10);
  var TYPE  = base * 3;
  var DUR_A = prm ? 150 : 6000;
  var DUR_B = prm ? 150 : 5000;
  var DEL_B = prm ?   0 : 600;

    // --- run guards / abort token ---
  var runToken = 0;        // verandert bij elke run/replay
  var isRunning = false;   // voorkomt dubbele starts


  function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }

  // ✅ reset() raakt de state NIET meer aan
  function reset(){
    extract.hidden = false;
    extract.classList.remove('is-leave','is-enter');
    barA.style.width='0%'; barB.style.width='0%';
    percA.textContent='0%'; percB.textContent='0%';
    frame.classList.add('is-enter');
    title.textContent=''; body.textContent=''; tag.textContent='';
  }

  function animateBar(fill, perc, dur, delay){
    return new Promise(function(res){
      if(prm){ fill.style.width='100%'; perc.textContent='100%'; return res(); }
      var start = performance.now() + (delay||0);
      function tick(now){
        var p = Math.min(1, Math.max(0, (now - start)/dur));
        var eased = 1 - Math.pow(1 - p, 3);
        var val = Math.round(eased * 100);
        fill.style.width = val + '%';
        perc.textContent = val + '%';
        if(p < 1) requestAnimationFrame(tick); else res();
      }
      requestAnimationFrame(tick);
    });
  }

  function typeInto(el, txt, step){
    return new Promise(function(res){
      if(prm){ el.textContent = txt; return res(); }
      el.textContent=''; var i=0;
      (function loop(){
        if(i<=txt.length){ el.textContent = txt.slice(0,i++); setTimeout(loop, step); }
        else res();
      })();
    });
  }

  // ✅ eerst resetten, dán state = running (blur gaat weg)
  async function run(){
    reset();
    root.setAttribute('data-state','running');

    await Promise.all([
      animateBar(barA, percA, DUR_A, 0),
      animateBar(barB, percB, DUR_B, DEL_B)
    ]);

    if(!prm){
      extract.classList.add('is-leave');
      frame.classList.remove('is-enter');
      await wait(360);
    } else {
      extract.hidden = true;
      frame.classList.remove('is-enter');
    }
    extract.hidden = true;

    for(var i=0;i<items.length;i++){
      var d = items[i].dataset;
      title.textContent=''; body.textContent=''; tag.textContent='';
      await typeInto(title, d.title||'', TYPE);
      await typeInto(body,  d.body ||'', TYPE);
      await typeInto(tag,   d.tag  ||'', Math.max(18, TYPE-8));
      if(!prm) await wait(180);
      if(i < items.length-1){
        frame.classList.add('is-leave');
        await wait(360);
        frame.classList.remove('is-leave');
      }
    }
    root.setAttribute('data-state','done');
  }

  // Handlers
  play  && play.addEventListener('click', run);

  // ✅ Replay: zet expliciet terug naar idle vóór reset()
  replay && replay.addEventListener('click', function(){
    root.setAttribute('data-state','idle');
    reset();
    setTimeout(run, 80);
  });

  // Init start als idle (zoals in HTML)
  reset();

  document.addEventListener('shopify:section:load', function(e){
    if(e && e.target && e.target.contains(root)){
      // section opnieuw opgebouwd → state respecteren
      if(root.getAttribute('data-state') === 'running' || root.getAttribute('data-state') === 'done'){
        // laat blur sowieso uit
        reset();
        root.setAttribute('data-state','done');
      }else{
        root.setAttribute('data-state','idle');
        reset();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
